
import React from 'react';

const TerviLogo = ({ size = 80 }) => {
    // Estilos para o texto da logo
    const logoStyle = {
        fontFamily: "Arial, sans-serif",
        fontSize: `${size}px`,
        fontWeight: 900,
        textAlign: 'center',

        // Gradiente conforme seu código
        background: `linear-gradient(
            to right,
            #193873 0%,
            #24589C 30%,
            #4CAF50 65%,
            #2E7D32 100%
        )`,

        // Configurações para aplicar o gradiente ao texto
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        color: 'transparent',

        // Adicionando a animação de "respiração" da sombra
        animation: 'logoBreath 3s ease-in-out infinite',
        userSelect: 'none'
    };

    return (
        <>
            <style>
                {`
                    @keyframes logoBreath {
                        0%, 100% {
                            text-shadow: 0 9px 10px rgba(0, 0, 0, 0.5);
                        }
                        50% {
                            text-shadow: 0 11px 12px rgba(0, 0, 0, 0.6);
                        }
                    }
                `}
            </style>
            <div style={logoStyle}>
                T-SERVI
            </div>
        </>
    );
};

export default TerviLogo;
